import { render, staticRenderFns } from "./message-call-c2c.vue?vue&type=template&id=609ab1f9&scoped=true"
import script from "./message-call-c2c.vue?vue&type=script&lang=ts"
export * from "./message-call-c2c.vue?vue&type=script&lang=ts"
import style0 from "./message-call-c2c.vue?vue&type=style&index=0&id=609ab1f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ab1f9",
  null
  
)

export default component.exports